export default {
    Membres(state, membres) {
        state.membres = membres
    },
    Total(state, total) {
        state.total = total
    }
}